import { render, staticRenderFns } from "./EventTypeIcon.vue?vue&type=template&id=4acb36fe&"
import script from "./EventTypeIcon.vue?vue&type=script&lang=ts&"
export * from "./EventTypeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports